






















































































import ContactProfileDto from '@/models/Contacts/ContactProfileDto'
import { Component } from 'vue-property-decorator'
import { ContactListModule } from '@/store/modules/contactList';
import PageNames from '@/router/PageNames';
import ContactListSearchCriteria from '@/components/Contacts/ContactListSearchCriteria.vue';
import ContactStatus from '@/components/Contacts/Display/ContactStatus.vue'
import GeoPoint from '@/models/Shared/GeoPoint';
import GiganautVue from '@/components/Shared/GiganautVue';
import Alert from '@/components/Shared/Alert.vue';
import OpenEntityInNewWindowBtn from '../Shared/OpenEntityInNewWindowBtn.vue';
import SelectableEntity from '@/models/Shared/SelectableEntity';
import { AppModule } from '@/store/modules/app';

@Component({
  name: 'ContactList',
  components: {
    Alert, ContactListSearchCriteria, ContactStatus
  }
})
export default class extends GiganautVue {

  center: GeoPoint = {lng: 0, lat: 0};

  async navigateToContact(contactId: string) {
    this.$router.push({ name: PageNames.AgencyContactDetails, params: { contactid: contactId } });
  }
  
  get searchOptionsVM() {
    return ContactListModule.contactSearchViewModel
  }

  get isAdmin() {
    return AppModule.userProfile.isAdministrator
  }

  get contacts() {
    return ContactListModule.contacts;
  }

  async centerMap(geo: GeoPoint) {
    this.center = geo;
  }

  get loading() {
    return ContactListModule.loading;
  }

  created() {
    this.getContacts();
  }

  private getContacts() {
    ContactListModule.searchContacts();
  }

  private search = '';
  
  private headers = [
    { text: 'Ref', value: 'sequenceNumber' },
    { text: 'Full Name', value: 'fullName' },
    { text: 'Position', value: 'positionName' },
    { text: this.Labels.company, value: 'companyBrandName' },
    { text: 'Email Address', value: 'emailAddress' },
    { text: 'Status' },
    { text: 'Actions' }
  ]
}
